module.exports = __webpack_public_path__ + "static/img/unlimited@2x.325f037e.png";